import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      width: "100%",
      maxWidth: 784,
      padding: "1.5rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "1rem",
    },
  },
  dialogTitle: {
    display: "flex",
    gap: "1rem",
    width: "100%",
    borderBottom: "none",
    backgroundColor: "#FFF",
    color: "#000",
    paddingBottom: 0,
    paddingTop: "16px",
    "& .MuiTypography-root": {
      display: "flex",
      gap: "0.5rem",
      width: "100%",
      alignItems: "center",
    },
  },
  dialogContent: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: "24px",
    paddingLeft: "2.9rem",
    fontFamily: "'Source Sans Pro'",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    width: "100%",
    background: "#fff",
    color: "rgba(0, 0, 0, 0.85)",
    flex: "none",
    order: 1,
    alignSelf: "stretch",
    flexGrow: 0,
  },
  dialogActions: {
    padding: "16px 24px",
    width: "100%",
    display: "flex",
    gap: "1rem",
    justifyContent: "right",
    borderTop: "none",
  },
  loadingContainer: {
    textAlign: "center",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  formContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  formContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& iframe": {
      width: "100%",
    },
  },
}));

const stylesExport = {
  useStyles,
};

export default stylesExport;
